import { useEffect, useState } from 'react';
import { fetchStaticPage } from 'src/client/api/services/static-page';
import { StaticPage } from 'src/shared/cms';
import { StaticPageType } from 'src/shared/types/cms';
import { BLOCKS, Document } from '@contentful/rich-text-types';
import { useLocale } from './use-locale';

export interface StaticPageDefinition {
    header: string;
    html: string;
    type: StaticPageType;
    richText: Document;
}

export const useStaticPage = (
    path: string,
    defaultStaticPage?: StaticPage,
): StaticPageDefinition => {
    const [staticPage, setStaticPage] = useState<StaticPage | undefined>(undefined);
    const [firstRender, setFirstRender] = useState<boolean>(true);
    const appDomain = useLocale().split('_')[0];

    const url: string = path.slice(1).toLowerCase() || '';

    useEffect(() => {
        if (!appDomain || !url) {
            return;
        }

        if (firstRender) {
            setFirstRender(false);
            if (defaultStaticPage) {
                setStaticPage(defaultStaticPage);
                return;
            }
        }

        fetchStaticPage(url, appDomain).then(response => {
            if (Array.isArray(response) && response.length > 0) {
                setStaticPage(response[0]);
            }
        });
    }, [url, appDomain]);

    if (!staticPage) {
        return {
            header: '',
            html: '',
            type: 'richText',
            richText: {
                nodeType: BLOCKS.DOCUMENT,
                data: {},
                content: [],
            },
        };
    }

    return {
        header: staticPage.fields.title,
        html:
            staticPage.fields.text.content
                .map((element: any) => element.content?.[0]?.value || '')
                .join(' ') || ' ',
        type: staticPage.fields.type,
        richText: staticPage.fields.text,
    };
};
